import { color, typeStyle } from '@m/alchemy-ui/theme';
import styled from 'styled-components';

export const Title = styled.div`
  ${typeStyle('headerM')};
  margin-bottom: 20px;
`;

export const FieldDescription = styled.p`
  ${typeStyle('captionM')};
  color: ${color('base', { palette: 'expressiveNeutral' })};
`;

export const RoleDataAccessProductAreaLabel = styled.span`
  ${typeStyle('labelM')};
`;

export const FiledLabel = styled.span`
  ${typeStyle('labelL')}
  color: ${color('typeBody')};
`;
